export default __webpack_public_path__ + "static/media/automovel.7df62342.png";